<script lang="ts">
	let {
		text,
		toHighlight = undefined,
		class: className = 'font-bold underline',
	}: { text: string; toHighlight?: string; class?: string } = $props();

	function splitAndKeepDelimiter(
		text: string,
		delimiter?: string,
	): { text: string; highlight: boolean }[] {
		text = text.trim();

		if (!delimiter) return [{ text, highlight: false }];
		delimiter = delimiter.toLowerCase();

		const result: { text: string; highlight: boolean }[] = [];
		let currentIndex = 0;
		let index: number;

		while ((index = text.toLowerCase().indexOf(delimiter, currentIndex)) !== -1) {
			if (index > currentIndex) {
				result.push({ text: text.substring(currentIndex, index), highlight: false });
			}
			currentIndex = index + delimiter.length;
			result.push({ text: text.substring(index, currentIndex), highlight: true });
		}
		if (currentIndex < text.length) {
			result.push({ text: text.substring(currentIndex), highlight: false });
		}
		return result;
	}
</script>

<span>
	{#each splitAndKeepDelimiter(text, toHighlight) as part, index (index)}
		{#if part.highlight}
			<span class={className}>{part.text}</span>
		{:else}
			<span>{part.text}</span>
		{/if}
	{/each}
</span>
